import { getRandomId } from './getRandomId';

type WithKey<T> = T & { key: string };

export const reformatItemsWithKey = <T>(items: T[]): WithKey<T>[] => {
  return items.map((item) => ({
    ...item,
    key: getRandomId()
  }));
};

export const removeKeyFromItems = <T>(items: WithKey<T>[]): T[] => {
  return items.map((item) => {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { key, ...rest } = item;
    return rest as T;
  });
};

export const removeKeyAndExtrasFromItems = <T>(
  items: (T & { key: string; requirementMetCandidatesCount?: number | null })[]
): T[] => {
  return items.map((item) => {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { key, requirementMetCandidatesCount, ...rest } = item;
    return rest as T;
  });
};
